import React from 'react';
import { GaugeIcon } from 'lucide-react';
import { promiseItems } from '../data/content';
export function PromiseSection() {
  return <section id="promise" aria-labelledby="promise-title" className="border-b border-white/5 bg-ink-800" data-id="element-153" data-mp="3tfk29kl1o3h7">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-154" data-mp="3olxotq723vkc">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-155" data-mp="3kmgi6tfw8sdl">
          Under the hood
        </p>
        <h2 id="promise-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-156" data-mp="3fl9b6wlkrx7z">
          Built to keep the promise.
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/60" data-id="element-157" data-mp="31o4a7b0pxojl">
          Speed to lead is either engineered or it is a slogan. Here is exactly how the
          under 60 seconds number holds up.
        </p>

        <ul className="mt-12 space-y-4" data-id="element-158" data-mp="zxj03ukixacr">
          {promiseItems.map(item => <li key={item.title} className="flex flex-col gap-4 rounded-xl border border-white/10 bg-ink-700 p-7 sm:flex-row sm:gap-6" data-id="element-159" data-mp="2bcq2bf2pvn4c">
              <span className="flex h-10 w-10 flex-none items-center justify-center rounded-lg border border-brand/30 bg-brand/10" data-id="element-160" data-mp="22ckzzjcdrex1">
                <GaugeIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-161" data-mp="26f7tdoop97wc" />
              </span>
              <div data-id="element-162" data-mp="2u4sead4eyf89">
                <h3 className="font-display text-lg font-semibold tracking-tight text-white" data-id="element-163" data-mp="2u4ambsosan65">
                  {item.title}
                </h3>
                <p className="mt-2 max-w-3xl text-sm leading-relaxed text-white/60" data-id="element-164" data-mp="2lbp4cesz8kid">
                  {item.body}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}